export default "__VITE_ASSET__De1p7V_L__"